import CloseIcon from '@mui/icons-material/Close';
import {
    AppBar,
    Box,
    Button,
    CircularProgress,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Grid,
    IconButton,
    Stack,
    Toolbar,
    Typography,
} from '@mui/material';
import React, { Fragment } from 'react';

const CommonDialog = ({
    loader,
    open,
    onClose,
    iconClose = false,
    onIconClose,
    onSave,
    onConfirm = () => {},
    dialogTitle,
    dialogSubtitle,

    dialogSubtitle2,
    dialogSubtitle3,
    dialogClaassName = 'commonDialog',
    subtitle2MarginTop = '16px',
    showSupplierInvoiceTable = false,
    supplierInvoiceData = [],

    buttonPadding = '16px 0 0 0',
    cancelButtonVariant = 'outlined',
    cancelButtonText = 'Cancel',
    cancelButtonWidth = '108px',

    saveButtonType = 'error',
    saveButtonVariant = 'contained',
    saveButtonText = 'Delete',
    saveButtonWidth = '103px',

    confirmButtonVariant = 'contained',
    confirmButtonText,
    confirmButtonWidth = '103px',
    confirmButtonType = 'secondary',
    onCancel,
}) => {
    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose(event, reason);
                }
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={dialogClaassName}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '0%',
                    left: '0%',
                    transform: 'translate(-0%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    width: '100%',
                    border: 'none',
                    borderRadius: '8px 8px 0px 0px',
                }}
            >
                <AppBar
                    color=""
                    variant="outlined"
                    style={{
                        width: 'inherit',
                        borderRadius: '8px 8px 0px 0px !important',
                    }}
                    sx={{
                        padding: '0 16px!important',
                    }}
                >
                    <Toolbar variant="regular" sx={{ color: 'black' }}>
                        <Typography variant="h6" width={'98%'}>
                            {dialogTitle}
                        </Typography>
                        {}
                        <Stack direction={'row'} spacing={0}>
                            <IconButton
                                onClick={() => {
                                    if (iconClose) {
                                        onIconClose();
                                    } else {
                                        onClose();
                                    }
                                }}
                                size="small"
                            >
                                <CloseIcon sx={{ fill: 'black', fontSize: 32 }} />
                            </IconButton>
                        </Stack>
                    </Toolbar>
                </AppBar>
            </Box>
            <Container
                style={{
                    marginTop: '64px',
                    padding: '16px',
                }}
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" sx={{ color: 'black' }}>
                        <div style={{ color: '#000' }}> {dialogSubtitle}</div>
                        {dialogSubtitle2 && <div style={{ marginTop: subtitle2MarginTop, color: '#000' }}>{dialogSubtitle2}</div>}
                        {dialogSubtitle3 && <div style={{ marginTop: subtitle2MarginTop, color: '#000' }}>{dialogSubtitle3}</div>}
                        {showSupplierInvoiceTable && supplierInvoiceData?.length > 0 && (
                            <div>
                                <Grid container mt={2} padding={1.5} bgcolor={'#F1F1F1'} borderRadius={1}>
                                    <Grid item xs={6}>
                                        <Typography color={'rgba(0, 0, 0, 0.87)'} fontSize={16} fontWeight={500} letterSpacing={'0.15px'} lineHeight={'150%'}>
                                            {' '}
                                            Supplier Invoice
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography color={'rgba(0, 0, 0, 0.87)'} fontSize={16} fontWeight={500} letterSpacing={'0.15px'} lineHeight={'150%'}>
                                            {' '}
                                            Cost
                                        </Typography>
                                    </Grid>
                                    {supplierInvoiceData?.map((item, index) => (
                                        <Fragment key={index}>
                                            <Grid item xs={6} mt={1}>
                                                <Typography
                                                    color={'rgba(0, 0, 0, 0.87)'}
                                                    fontSize={16}
                                                    fontWeight={400}
                                                    letterSpacing={'0.15px'}
                                                    lineHeight={'150%'}
                                                >
                                                    {' '}
                                                    {item.invoice}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} mt={1}>
                                                <Typography
                                                    color={'rgba(0, 0, 0, 0.87)'}
                                                    fontSize={16}
                                                    fontWeight={400}
                                                    letterSpacing={'0.15px'}
                                                    lineHeight={'150%'}
                                                >
                                                    {' '}
                                                    {item.cost}
                                                </Typography>
                                            </Grid>
                                        </Fragment>
                                    ))}
                                </Grid>
                            </div>
                        )}
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ padding: buttonPadding }}>
                    <Button onClick={onCancel || onClose} variant={cancelButtonVariant} disabled={loader} style={{ width: cancelButtonWidth }}>
                        {cancelButtonText}
                    </Button>
                    <Button onClick={onSave} autoFocus color={saveButtonType} variant={saveButtonVariant} disabled={loader} style={{ width: saveButtonWidth }}>
                        {loader ? <CircularProgress size={24} sx={{ color: 'white' }} /> : saveButtonText}
                    </Button>
                    {confirmButtonText && (
                        <Button
                            onClick={onConfirm}
                            autoFocus
                            color={confirmButtonType}
                            variant={confirmButtonVariant}
                            disabled={loader}
                            style={{ width: confirmButtonWidth }}
                        >
                            {loader ? <CircularProgress size={24} sx={{ color: 'white' }} /> : confirmButtonText}
                        </Button>
                    )}
                </DialogActions>
            </Container>
        </Dialog>
    );
};

export default CommonDialog;
